// Gabung deret GPS satelit dengan RPM & AE di jam yang sama. Murni, nol import.

const hourOf = (timestamp) => Math.floor(timestamp / 3600);

function groupByHour(series) {
  const byHour = new Map();
  series.forEach((row) => {
    const hour = hourOf(row.timestamp);
    if (!byHour.has(hour)) {
      byHour.set(hour, []);
    }
    byHour.get(hour).push(row);
  });
  return byHour;
}

export function mergeSatSeries(gpsSeries, rpmSeries, aeSeries) {
  const rpmByHour = groupByHour(rpmSeries);
  const aeByHour = groupByHour(aeSeries);

  return gpsSeries.map((gpsPoint) => {
    const gpsHour = hourOf(gpsPoint.timestamp);
    const matchingRpmData = rpmByHour.get(gpsHour) || [];
    const matchingAeData = aeByHour.get(gpsHour) || [];

    // yang pertama ketemu per tipe yang dipakai
    const portRpm = matchingRpmData.find((r) => r.type === 'PORT');
    const starboardRpm = matchingRpmData.find((r) => r.type === 'STARBOARD');
    const centerRpm = matchingRpmData.find((r) => r.type === 'CENTER');

    // AE berstatus 1, kalau gak ada ambil yang pertama
    const activeAe = matchingAeData.find((ae) => ae.status === 1) || matchingAeData[0];

    return {
      ...gpsPoint,
      // rpm 0 = mesin mati, tetap data
      portRpm: portRpm?.rpm ?? null,
      starboardRpm: starboardRpm?.rpm ?? null,
      centerRpm: centerRpm?.rpm ?? null,
      currentAe: activeAe?.no || null,
      track: gpsPoint.track || gpsPoint.heading || 0,
    };
  });
}

export default mergeSatSeries;
